// eslint-disable-next-line no-unused-vars
export const validateForm = (values) => {
  const errors = {};

  return errors;
};

export default validateForm;



// WEBPACK FOOTER //
// ./app/components/ProcessoImpresa/ImpresaForm/Base/validation.js